<template>

    <div v-if="counter > 0" class="fixed xl:hidden bottom-0 left-0 flex z-100 bg-black border-t border-primary-300">
        <div @click="openCart" class="flex flex-shrink-1 w-[60px] xl:w-auto h-full justify-center items-center px-4 xl:px-8 group border-l border-white/30 hover:bg-white/5 transition-all">
            <span class="inline-flex items-center w-[40px] h-[37px] mx-auto relative left-0.5 xl:left-1 bottom-2 xl:bottom-1">
                <span class="flex h-full items-end">
                    <svg class="w-[16px] h-[20px] xl:w-[19px] xl:h-[22px]" xmlns="http://www.w3.org/2000/svg" width="19.635" height="22.73" viewBox="0 0 19.635 22.73">
                        <g data-name="Raggruppa 1300" transform="translate(-4110.463 -41.242)">
                            <path id="Tracciato_1456" data-name="Tracciato 1456" d="M4112,48.131h16.567l1,15.341H4111Z" fill="none" stroke="#fff" stroke-width="1"/>
                            <path id="Tracciato_1457" data-name="Tracciato 1457" d="M4117.447,55.8V44.575a2.833,2.833,0,0,1,2.833-2.833h0a2.833,2.833,0,0,1,2.834,2.833V55.8" fill="none" stroke="#fff" stroke-width="1"/>
                        </g>
                    </svg>
                </span>
                <span class="relative h-full -ml-1 -mb-5 xl:mb-0 xl:ml-0">
                    <span class="w-[17px] h-[17px] xl:w-[18px] xl:h-[18px] bg-primary-400 rounded-full inline-flex items-center justify-center text-xxs xl:text-xxs text-white text-center font-alternate -tracking-[.01rem] leading-none">
                        <span class="block mx-auto relative" v-text="counter"></span>
                    </span>
                </span>
            </span>
        </div>

        <div class="carrello-mobile-fixed__btn">
            <a @click="openCart" href="javascript:void(0)"><img src="/images/svg/roeno-17.svg" alt=""/></a>
        </div>

    </div>

</template>
<style  scoped>
    .shake {
        animation: shake 1s cubic-bezier(.36,.07,.19,.97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    @keyframes shake {
    10%, 90% {
        transform: translateX(-1px);
    }

    20%, 80% {
        transform: translateX(2px);
    }

    30%, 50%, 70% {
        transform: translateX(-4px);
    }

    40%, 60% {
        transform: translateX(4px);
    }
    }

</style>
<script>
export default {
    props: ['initCounter'],
    data() {
        return {
            shake:false,
            counter: 0,
            show: false,
        }
    },
    watcher: {
      counter: function(n, o) {
          if(n > 0 && o == 0) {

          }
      }
    },
    mounted() {
        this.counter = parseInt(this.initCounter);

        if(this.counter > 0) {
            setTimeout(() => {
                this.show = true;
            }, 700)
        }

        this.$eventHub.$on('cart.added', payload => {
            this.counter = parseInt(payload.count);
            this.shake = true;

            setTimeout(() => {
                this.shake = false;
            }, 1000);
        });

        this.$eventHub.$on('cart.updated.simpleQty', payload => {
            this.counter = payload;
        });

    },
    methods: {
      openCart() {
          if(window.innerWidth < 1280) {
              window.location.href = this.$root.langRoute('/carrello');
          }else{
              this.$eventHub.$emit('cart.show', {});
          }
      },
      getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                this.counter = response.data.count;
            })
        },
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }

            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }

            return tmp;
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.updated.simpleQty');
    },
}
</script>
